import { useEffect, useRef } from "react";
import { useAppDispatch } from "@common/store/hooks";
import { applyTokens } from "@common/store/slices/authSlice";
import { DESKTOP_SIGN_IN, desktop, isDesktop } from "./desktop";

// The desktop app's half of sign-in: every "Sign in" goes through
// redirectToLogin, which in the app raises DESKTOP_SIGN_IN; this opens the
// system browser and stores the tokens it brings back, as HashTokenHandler
// does on the website.
export default function DesktopSignIn() {
  const dispatch = useAppDispatch();
  const running = useRef(false);

  useEffect(() => {
    if (!isDesktop) return;
    const onSignIn = () => {
      if (running.current) return;
      running.current = true;
      desktop
        .signIn()
        .then((tokens) => dispatch(applyTokens(tokens)))
        .catch((e: unknown) => console.error("sign-in:", e))
        .finally(() => {
          running.current = false;
        });
    };
    window.addEventListener(DESKTOP_SIGN_IN, onSignIn);
    return () => window.removeEventListener(DESKTOP_SIGN_IN, onSignIn);
  }, [dispatch]);

  return null;
}
